"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconType = exports.Icon = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var TwsIcon = styled_components_1.default.i.attrs({
    className: 'tws-i-icon',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return (props.disabled ? 'color: #cccccc;' : null); });
TwsIcon.displayName = 'TwsIcon';
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon(props) {
        return _super.call(this, props) || this;
    }
    Icon.prototype.render = function () {
        var className = 'icon-' + this.props.name + (this.props.className ? ' ' + this.props.className : '') + (this.props.disabled ? ' disabled-icon' : '');
        return React.createElement(TwsIcon, __assign({ role: 'icon' }, this.props, { style: this.props.style, className: className, disabled: this.props.disabled }));
    };
    return Icon;
}(React.Component));
exports.Icon = Icon;
var IconType;
(function (IconType) {
    IconType["act"] = "act";
    IconType["add"] = "add";
    IconType["admin"] = "admin";
    IconType["administer"] = "administer";
    IconType["alert"] = "alert";
    IconType["angleDown"] = "angle-down";
    IconType["angleLeft"] = "angle-left";
    IconType["angleRight"] = "angle-right";
    IconType["angleUp"] = "angle-up";
    IconType["arrowDown"] = "arrow-down";
    IconType["arrowLeft"] = "arrow-left";
    IconType["arrowRight"] = "arrow-right";
    IconType["arrowUp"] = "arrow-up";
    IconType["back"] = "back";
    IconType["barChart"] = "bar-chart";
    IconType["branching"] = "branching";
    IconType["calendar"] = "calendar";
    IconType["caretDown"] = "caret-down";
    IconType["caretLeft"] = "caret-left";
    IconType["caretRight"] = "caret-right";
    IconType["caretUp"] = "caret-up";
    IconType["close"] = "close";
    IconType["contact"] = "contact";
    IconType["contract"] = "contract";
    IconType["copy"] = "copy";
    IconType["debug"] = "debug";
    IconType["delete"] = "delete";
    IconType["design"] = "design";
    IconType["development"] = "development";
    IconType["download"] = "download";
    IconType["edit"] = "edit";
    IconType["email"] = "email";
    IconType["error"] = "error";
    IconType["events"] = "events";
    IconType["exclamation"] = "exclamation";
    IconType["expand"] = "expand";
    IconType["explore"] = "explore";
    IconType["extras"] = "extras";
    IconType["file"] = "file";
    IconType["filter"] = "filter";
    IconType["filterSave"] = "filter-save";
    IconType["goals"] = "goals";
    IconType["goTo"] = "go-to";
    IconType["grid"] = "grid";
    IconType["help"] = "help";
    IconType["hierarchy"] = "hierarchy";
    IconType["home"] = "home";
    IconType["idea"] = "idea";
    IconType["impersonate"] = "impersonate";
    IconType["info"] = "info";
    IconType["inventory"] = "inventory";
    IconType["language"] = "language";
    IconType["link"] = "link";
    IconType["list"] = "list";
    IconType["loading"] = "loading";
    IconType["maintenance"] = "maintenance";
    IconType["minus"] = "minus";
    IconType["monitor"] = "monitor";
    IconType["moreInfo"] = "more-info";
    IconType["move"] = "move";
    IconType["no"] = "no";
    IconType["note"] = "note";
    IconType["openLink"] = "open-link";
    IconType["openModal"] = "open-modal";
    IconType["pageBreak"] = "page-break";
    IconType["person"] = "person";
    IconType["pieChart"] = "pie-chart";
    IconType["plus"] = "plus";
    IconType["preview"] = "preview";
    IconType["print"] = "print";
    IconType["ratings"] = "ratings";
    IconType["remove"] = "remove";
    IconType["report"] = "report";
    IconType["search"] = "search";
    IconType["sectionBreak"] = "section-break";
    IconType["sectionHeader"] = "section-header";
    IconType["security"] = "security";
    IconType["social"] = "social";
    IconType["switch"] = "switch";
    IconType["tableError"] = "table-error";
    IconType["tableWarning"] = "table-warning";
    IconType["tap"] = "tap";
    IconType["text"] = "text";
    IconType["tools"] = "tools";
    IconType["total"] = "total";
    IconType["tour"] = "tour";
    IconType["trend"] = "trend";
    IconType["undo"] = "undo";
    IconType["unlink"] = "unlink";
    IconType["upload"] = "upload";
    IconType["users"] = "users";
    IconType["warning"] = "warning";
    IconType["warningAlt"] = "warning-alt";
    IconType["yes"] = "yes";
})(IconType = exports.IconType || (exports.IconType = {}));
var templateObject_1;
